/* eslint-disable @typescript-eslint/no-explicit-any */
import NoNullFields from '~/lib/NoNullFields'
import { QUOTE_MODEL_REVISION_STATES } from '~/lib/quoteConstants'
import Subset from '~/lib/Subset'
import { QuoteType as EnumQuoteType } from '~/__generated__/globalTypes'
import { REQUESTED } from '~/lib/quoteStatuses'
import { configurationTabQuery_quote as configurationTabData } from '~/redux-modules/query-refactor/__generated__/configurationTabQuery'
import {
    coreQuoteDetails_quote as CoreQuoteDetailsDataType,
    coreQuoteDetails_quote_quoteAttachments as LatestAttachmentRevisionType,
    coreQuoteDetails_quote_quoteModels as QuoteModelsType,
    coreQuoteDetails_quote_platformOrder as PlatformOrderType,
} from '~/redux-modules/query-refactor/__generated__/coreQuoteDetails'
import { detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs_quote as IMFeedbackAddReqUnconfiguredConfigModalDataType } from '~/redux-modules/query-refactor/__generated__/detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs'
import { detailsForFeedbackThreadsAddReqModalConfigTab_quote as FeedbackThreadsAddReqModalDataType } from '~/redux-modules/query-refactor/__generated__/detailsForFeedbackThreadsAddReqModalConfigTab'
import { drawingAnalysisTabQuery_quote as DrawingAnalysisTabDataType } from '~/redux-modules/query-refactor/__generated__/drawingAnalysisTabQuery'

import {
    configurationTabQueryFailure,
    configurationTabQuerySuccess,
    setQuoteDetailsPageLoading,
    coreQuoteDetailsQuerySuccess,
    coreQuoteDetailsQueryFailure,
    setLegacyQuoteDetailsQueryLoading,
    legacyQuoteDetailsQueryFailure,
    imFeedbackAddReqUnconfiguredConfigModalQueryFailure,
    imFeedbackAddReqUnconfiguredConfigModalQuerySuccess,
    configTabForFeedbackThreadsAddReqModalQuerySuccess,
    configTabForFeedbackThreadsAddReqModalQueryFailure,
    drawingAnalysisTabQuerySuccess,
    drawingAnalysisTabQueryFailure,
    coreQuoteDetailsQueryReset,
} from './actions'

export type SetQuoteDetailsPageLoadingAction = ReturnType<
    typeof setQuoteDetailsPageLoading
>

export type ConfigurationTabSuccessAction = ReturnType<
    typeof configurationTabQuerySuccess
>

export type ConfigurationTabFailureAction = ReturnType<
    typeof configurationTabQueryFailure
>

export type CoreQuoteDetailsSuccessAction = ReturnType<
    typeof coreQuoteDetailsQuerySuccess
>

export type CoreQuoteDetailsFailureAction = ReturnType<
    typeof coreQuoteDetailsQueryFailure
>

export type SetLegacyQuoteDetailsQueryLoadingAction = ReturnType<
    typeof setLegacyQuoteDetailsQueryLoading
>

export type LegacyQuoteDetailsQueryFailureAction = ReturnType<
    typeof legacyQuoteDetailsQueryFailure
>
export type ConfigTabForFeedbackThreadsAddReqModalSuccessAction = ReturnType<
    typeof configTabForFeedbackThreadsAddReqModalQuerySuccess
>
export type ConfigTabForFeedbackThreadsAddReqModalFailureAction = ReturnType<
    typeof configTabForFeedbackThreadsAddReqModalQueryFailure
>

export type drawingAnalysisTabSuccessAction = ReturnType<
    typeof drawingAnalysisTabQuerySuccess
>

export type drawingAnalysisTabFailureAction = ReturnType<
    typeof drawingAnalysisTabQueryFailure
>

export type IMFeedbackAddReqUnconfiguredConfigModalSuccessAction = ReturnType<
    typeof imFeedbackAddReqUnconfiguredConfigModalQuerySuccess
>

export type IMFeedbackAddReqUnconfiguredConfigModalFailureAction = ReturnType<
    typeof imFeedbackAddReqUnconfiguredConfigModalQueryFailure
>

export type coreQuoteDetailsQueryResetAction = ReturnType<
    typeof coreQuoteDetailsQueryReset
>

export type INITIAL_STATE_TYPE = {
    configurationTabQuery: {
        configurationTabData: configurationTabData | null
        errorMessage: string | null
    }
    coreQuoteDetails: {
        coreQuoteDetailsData: CoreQuoteDetailsDataType | null
        errorMessage: string | null
    }
    legacyQuoteDetails: {
        errorMessage: string | null
    }
    detailsForFeedbackThreadsAddReqModalConfigTab: {
        detailsForFeedbackThreadsAddReqModalConfigTabData: FeedbackThreadsAddReqModalDataType | null
        errorMessage: string | null
    }
    drawingAnalysisQuery: {
        drawingAnalysisTabData: DrawingAnalysisTabDataType | null
        errorMessage: string | null
    }
    detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs: {
        detailsForIMFeedbackAddReqUnconfiguredConfigModalTabsData: IMFeedbackAddReqUnconfiguredConfigModalDataType | null
        errorMessage: string | null
    }
    loading: boolean
    error: boolean
}

export type QuoteDetailsPageActions =
    | SetQuoteDetailsPageLoadingAction
    | ConfigurationTabSuccessAction
    | ConfigurationTabFailureAction
    | CoreQuoteDetailsSuccessAction
    | CoreQuoteDetailsFailureAction
    | SetLegacyQuoteDetailsQueryLoadingAction
    | LegacyQuoteDetailsQueryFailureAction
    | IMFeedbackAddReqUnconfiguredConfigModalFailureAction
    | IMFeedbackAddReqUnconfiguredConfigModalSuccessAction
    | ConfigTabForFeedbackThreadsAddReqModalSuccessAction
    | ConfigTabForFeedbackThreadsAddReqModalFailureAction
    | drawingAnalysisTabSuccessAction
    | drawingAnalysisTabFailureAction
    | coreQuoteDetailsQueryResetAction

export type NoNullStateType = NoNullFields<INITIAL_STATE_TYPE>

export type CORE_SUCCESS = Subset<
    NoNullStateType,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: CoreQuoteDetailsDataType
        }
        loading: boolean
        error: boolean
    }
>

export type NoPartsType = Subset<
    NoNullStateType,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: {
                id: string
                name: string
                lastModified: Date
                type: string
                quoteAttachments: NoNullFields<LatestAttachmentRevisionType>
            }
        }
        loading: boolean
        error: boolean
    }
>

export const isNoPartState = (
    state: INITIAL_STATE_TYPE | NoPartsType,
): state is NoPartsType => {
    const isNoPart = state.coreQuoteDetails.coreQuoteDetailsData

    return (
        isNoPart?.id &&
        isNoPart?.name &&
        isNoPart?.lastModified &&
        isNoPart?.quoteAttachments?.items?.length === 0 &&
        isNoPart?.type
    )
}

export type UNCONFIGURED_STATE = NoNullFields<INITIAL_STATE_TYPE>
export type UnconfiguredParts = Subset<
    UNCONFIGURED_STATE,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: {
                id: string
                name: string
                status: string
                lastModified: Date
                quoteAttachments: NoNullFields<LatestAttachmentRevisionType>
                quoteModels: NoNullFields<QuoteModelsType>
            }
        }
        error: boolean
        loading: boolean
    }
>

export const isUnconfiguredPartsState = (
    state: INITIAL_STATE_TYPE | UnconfiguredParts,
): state is UnconfiguredParts => {
    const coreQuoteDetails = state.coreQuoteDetails.coreQuoteDetailsData
    const selectedQuoteModelRevision =
        coreQuoteDetails?.quoteModels?.items[0]?.selectedQuoteModelRevision

    return (
        coreQuoteDetails?.id &&
        coreQuoteDetails?.name &&
        coreQuoteDetails?.status &&
        coreQuoteDetails?.lastModified &&
        selectedQuoteModelRevision?.state &&
        selectedQuoteModelRevision?.dfmFeedback &&
        selectedQuoteModelRevision.partRevision?.analysisErrorCode === null &&
        selectedQuoteModelRevision?.modelConfiguration?.productionLeadTime
            ?.priorityId &&
        coreQuoteDetails?.quoteAttachments.items.length >= 0
    )
}
export type ConfiguredStateType = Subset<
    NoNullStateType,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: {
                id: string
                name: string
                lastModified: Date
                status: string
                quoteAttachments: NoNullFields<LatestAttachmentRevisionType>
                quoteModels: NoNullFields<QuoteModelsType>
            }
        }
        loading: boolean
        error: boolean
    }
>

export type RfqTypes = Subset<
    NoNullStateType,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: {
                id: string
                name: string
                lastModified: Date
                status: string
                quoteAttachments: NoNullFields<LatestAttachmentRevisionType>
                quoteModels: NoNullFields<QuoteModelsType>
            }
        }
        loading: boolean
        error: boolean
    }
>

export const isConfiguredState = (
    state: INITIAL_STATE_TYPE | ConfiguredStateType,
): state is ConfiguredStateType => {
    const coreQuoteDetails = state.coreQuoteDetails.coreQuoteDetailsData
    const selectedQuoteModelRevision =
        coreQuoteDetails?.quoteModels?.items[0]?.selectedQuoteModelRevision

    return !!(
        coreQuoteDetails?.id &&
        coreQuoteDetails?.name &&
        coreQuoteDetails?.lastModified &&
        coreQuoteDetails?.status &&
        coreQuoteDetails?.quoteAttachments.items.length >= 0 &&
        selectedQuoteModelRevision?.state &&
        selectedQuoteModelRevision?.dfmFeedback[0]?.severity &&
        selectedQuoteModelRevision?.quantityRangeStatus &&
        selectedQuoteModelRevision?.processesDetails
            ?.isBusinessAccountDiscountApplied &&
        selectedQuoteModelRevision?.processesDetails?.totalPrice &&
        selectedQuoteModelRevision?.modelConfiguration?.productionLeadTime
            ?.priorityId
    )
}

export const isRfqType = (
    state: INITIAL_STATE_TYPE | RfqTypes,
): state is RfqTypes => {
    const coreQuoteDetails = state.coreQuoteDetails.coreQuoteDetailsData

    return (
        coreQuoteDetails?.id &&
        coreQuoteDetails?.name &&
        coreQuoteDetails.lastModified &&
        coreQuoteDetails.status &&
        coreQuoteDetails?.quoteAttachments.items.length > 0 &&
        coreQuoteDetails?.quoteModels?.items?.some(
            item =>
                item?.selectedQuoteModelRevision?.state ===
                QUOTE_MODEL_REVISION_STATES.NEEDS_RFQ,
        )
    )
}

export type QuoteRequestedStateType = Subset<
    NoNullStateType,
    {
        coreQuoteDetails: {
            coreQuoteDetailsData: {
                id: string
                name: string
                status: string
                lastModified: Date
                isQuoteInRfqState: boolean
                type: EnumQuoteType
                isExpired: boolean
                isQuotePurchasable: boolean
                productionPartsSubtotalInCents: number
                moldToolSubtotalInCents: number
                depositInCents: number
                subTotalInCents: number
                slowestShipDateEstimate: Date
                expiration: any
                platformOrder: PlatformOrderType
                quoteAttachments: NoNullFields<LatestAttachmentRevisionType>
                quoteModels: NoNullFields<QuoteModelsType>
            }
        }
        loading: boolean
        error: boolean
    }
>

export const isQuoteRequestedState = (
    state: INITIAL_STATE_TYPE | QuoteRequestedStateType,
): state is QuoteRequestedStateType => {
    const coreQuoteDetails = state.coreQuoteDetails.coreQuoteDetailsData
    const selectedQuoteModelRevision =
        coreQuoteDetails?.quoteModels?.items[0]?.selectedQuoteModelRevision

    return (
        coreQuoteDetails?.id &&
        coreQuoteDetails?.name &&
        coreQuoteDetails?.type === EnumQuoteType['generic'] &&
        coreQuoteDetails?.lastModified &&
        coreQuoteDetails?.status === REQUESTED &&
        !coreQuoteDetails?.isQuoteInRfqState &&
        !coreQuoteDetails?.isExpired &&
        !coreQuoteDetails?.isQuotePurchasable &&
        !coreQuoteDetails?.depositInCents &&
        !coreQuoteDetails?.expiration &&
        !coreQuoteDetails?.moldToolSubtotalInCents &&
        coreQuoteDetails?.productionPartsSubtotalInCents &&
        coreQuoteDetails?.subTotalInCents &&
        coreQuoteDetails?.slowestShipDateEstimate &&
        !coreQuoteDetails?.platformOrder &&
        coreQuoteDetails?.quoteAttachments?.items?.length >= 0 &&
        selectedQuoteModelRevision?.state &&
        selectedQuoteModelRevision?.dfmFeedback &&
        selectedQuoteModelRevision?.quantityRangeStatus &&
        selectedQuoteModelRevision?.processesDetails
    )
}
